export default __webpack_public_path__ + "smop-landing.d1b049bd74c2d525b6054e93d5dd9dbf.png";